<div class="loading-spinner">
	<div class="loading-spinner-layer">
		<div class="loading-spinner-circle-clipper loading-spinner-left">
			<div class="loading-spinner-circle"></div>
		</div>
		<div class="loading-spinner-gap-patch">
			<div class="loading-spinner-circle"></div>
		</div>
		<div class="loading-spinner-circle-clipper loading-spinner-right">
			<div class="loading-spinner-circle"></div>
		</div>
	</div>
</div>